import React, { useMemo } from "react";
import styles from "./breadcrumb.module.scss";
import { selectProduct } from "@/store/slices/product";
import { useSelector } from "react-redux";
import Link from "next/link";

const ProductDetailsBreadcrumbs = () => {
  const productState = useSelector(selectProduct);

  const category = useMemo(() => {
    return productState.data?.categories?.[0] || null;
  }, [productState.data?.categories]);

  return (
    <div className={styles.breadcrumb_main}>
      <div className={`${styles.container} ${"container position-inherit"}`}>
        <div className="row align-items-center">
          <div className="col-12">
            <nav
              className={styles.breadcrumb_container}
              aria-label="breadcrumb"
            >
              <Link href="/">Home</Link>
              <span className={styles.separator}>&gt;</span>
              {category && (
                <>
                  <Link href={`/jewellery/category/${category.slug}`}>
                    <a>{category.name}</a>
                  </Link>
                  <span className={styles.separator}>&gt;</span>
                </>
              )}
              <span className={styles.active}>{productState.data?.title}</span>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsBreadcrumbs;
